import { render, staticRenderFns } from "./ShengJiaolianList.vue?vue&type=template&id=0d36a931&"
import script from "./ShengJiaolianList.vue?vue&type=script&lang=js&"
export * from "./ShengJiaolianList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports